import Flickity from 'flickity';
import 'flickity/css/flickity.css';

(function (Drupal) {
  Drupal.behaviors.useFlickityContainersMb = {
    attach: function (context, settings) {
      const flickityContainersMb = document.querySelectorAll('.useflickity--groupcells-only-mb .view-content', context);
      const deviceDetect = {
        breakpointDesktop: 768,
        isMobile: () => {
          return window.matchMedia(`(max-width: ${deviceDetect.breakpointDesktop}px)`).matches;
        },
      };

      if (deviceDetect.isMobile()) {
        flickityContainersMb.forEach(container => {          
          new Flickity(container, {
            cellAlign: 'center',
            contain: true,
            groupCells: true,
            prevNextButtons: false,
            pageDots: true,   
          });
        });
      }
    }
  }
})(Drupal);
